import styled from 'styled-components';
import Heading from '@atoms/Heading/Heading';
import { rem } from 'polished';
import Text from '@atoms/Text/Text';

export const StyledVoucherHeading = styled(Heading)`
  margin-bottom: ${rem(25)};
`;

export const StyledTextWithMargin = styled(Text)`
  margin-bottom: ${rem(25)};
`;
